import { Link as RouterLink } from 'react-router-dom'
import Link from '@material-ui/core/Link'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import { FiGithub, FiInstagram, FiLinkedin } from 'react-icons/fi';
import { AiOutlineCopyrightCircle } from 'react-icons/ai'
import "./Footer.css";

const Footer = () => {

    return(
      <Grid container className="notranslate Footer" translate="no" alignItems="center">
      {/*xs={12} sm={5} md={3} lg={4}*/}
        <Grid 
          item container 
          className="footer-elements-container" 
          xs={12} sm={12} md={12} lg={4} 
          justifyContent="flex-start" 
          alignItems="center"
        > 
          <Link component={RouterLink} to="/projects">
          <Typography className="typography-footer title-footer">JuanGP-Programador</Typography>
          {/* <Typography className="typography-footer">
            <IconButton className="icon-button" title="Principal" target="_top" href="/projects"> 
                <AiOutlineHome size={"1em"} />
            </IconButton>
          </Typography> */}
          </Link>
        </Grid>

        {/*xs={12} sm={4} md={4} lg={6}*/}
        {/*xs={12} sm={5} md={4} lg={4}*/}
        <Grid item container className="footer-elements-container" xs={12} sm={12} md={12} lg={4} display="inline" justifyContent="center">
          <Typography className="typography-footer">
            <IconButton className="icon-button" title="Instagram" tarjet="_top" href="https://www.instagram.com/juanmgarciapereira/">
              <FiInstagram />
            </IconButton>
          </Typography>
          <Typography className="typography-footer">
            <IconButton className="icon-button" title="Linkedin" tarjet="_top" href="https://www.linkedin.com/in/juan-garcia-pereira/">
              <FiLinkedin />
            </IconButton>
          </Typography>
          <Typography className="typography-footer">
            <IconButton className="icon-button" title="GitHub" tarjet="_top" href="https://github.com/garciapereirajuan/">
              <FiGithub />
            </IconButton>
          </Typography>
        </Grid>
{/*        <div className="footer-elements-container" style={{display: 'flex', margin: '0 auto'}}>
          <Typography className="typography-footer">
            <IconButton className="icon-button" title="Instagram" tarjet="_top" href="https://www.instagram.com/juanmgarciapereira/">
              <FiInstagram />
            </IconButton>
          </Typography>
          <Typography className="typography-footer">
            <IconButton className="icon-button" title="Linkedin" tarjet="_top" href="https://www.linkedin.com/in/juan-garcia-pereira/">
              <FiLinkedin />
            </IconButton>
          </Typography>
          <Typography className="typography-footer">
            <IconButton className="icon-button" title="GitHub" tarjet="_top" href="https://github.com/garciapereirajuan/">
              <FiGithub />
            </IconButton>
          </Typography>
        </div>*/}
        {/*xs={12} sm={3} md={5} lg={4}*/}
        <Grid item xs={12} sm={12} md={12} lg={4} className="footer-elements-container" style={{textAlign: 'center', color: "#fff"}}>
            <Typography className='description'>Apasionado por la programación</Typography>   
        </Grid>
        <Grid item container style={{background: "#373737", color: 'grey'}} className="footer-elements-container" xs={12} justifyContent="center" alignItems='center'>
          <span className="description-me">
            Creado con 💚
          </span>
        </Grid>
{/*        <Grid item container className="footer-elements-container" xs={12} sm={3} md={4} lg={3} display="inline" justifyContent="flex-end">
          <Typography className="typography-footer copyright">
            Copyright 2021 - All Rights Reserved
          </Typography>
        </Grid>*/}
      </Grid>
    );
}

export default Footer;